// Utilidades de formato de captura fiscal (detalles que se sienten premium).
import i18n from '@/i18n';

// 2-nov (web-interface-guidelines, Intl): montos, fechas y números SIEMPRE con
// el idioma activo de la app (no el del navegador ni 'en-US' fijo). Español de
// EE. UU. (es-US): el dinero se lee como en el IRS ($2,490.00) y la fecha en
// orden hispano (2/11/2026); con 'es' a secas saldría «2490,00 US$».
const lang = () => (i18n.language?.startsWith('es') ? 'es-US' : 'en-US');

/** Monto en USD con el formato del idioma activo. */
export function fmtUsd(amount: number, opts: Intl.NumberFormatOptions = {}): string {
  return new Intl.NumberFormat(lang(), { style: 'currency', currency: 'USD', ...opts }).format(amount);
}

/** Monto en centavos → USD con el formato del idioma activo. */
export function fmtCents(cents: number, opts: Intl.NumberFormatOptions = {}): string {
  return fmtUsd(cents / 100, opts);
}

/** Fecha corta con el idioma activo. */
export function fmtDate(d: Date | string | number, opts?: Intl.DateTimeFormatOptions): string {
  return new Date(d).toLocaleDateString(lang(), opts);
}

/** Número con separadores del idioma activo. */
export function fmtNumber(n: number): string {
  return n.toLocaleString(lang());
}

/** Normaliza texto de dinero a número (acepta "$1,234.56", "1234,56" no; USD). */
export function parseMoney(input: string): number {
  const clean = input.replace(/[^0-9.]/g, '');
  const n = Number.parseFloat(clean);
  return Number.isFinite(n) ? n : 0;
}

/** Formatea un número como USD con separador de miles ($1,234.56). */
export function formatMoney(n: number): string {
  if (!Number.isFinite(n) || n === 0) return '';
  return n.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

/** Máscara de SSN mientras se escribe: 123456789 → 123-45-6789. */
export function maskSSN(input: string): string {
  const digits = input.replace(/\D/g, '').slice(0, 9);
  if (digits.length <= 3) return digits;
  if (digits.length <= 5) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5)}`;
}

/** Ocultamiento para mostrar: solo los últimos 4 (•••-••-1234). */
export function redactSSN(ssn: string): string {
  const digits = ssn.replace(/\D/g, '');
  return digits.length >= 4 ? `•••-••-${digits.slice(-4)}` : '';
}
